import { render, staticRenderFns } from "./FeaturesPreview.vue?vue&type=template&id=33cfe8b7&scoped=true&"
import script from "./FeaturesPreview.vue?vue&type=script&lang=js&"
export * from "./FeaturesPreview.vue?vue&type=script&lang=js&"
import style0 from "./FeaturesPreview.vue?vue&type=style&index=0&id=33cfe8b7&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cfe8b7",
  null
  
)

export default component.exports